"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sample = exports.areNumberArrayEqual = exports.makeValueMap = exports.keyById = exports.modifyArrayElementInPlaceById = exports.concatAndDedupeById = exports.ensureArray = exports.arrayFromRange = void 0;
function arrayFromRange(len, start, modifier) {
    const it = {
        [Symbol.iterator]() {
            let i = start | 0;
            const end = (i + len) | 0;
            return {
                next() {
                    if (i >= end) {
                        return { done: true, value: undefined };
                    }
                    const value = modifier ? modifier(i) : i;
                    ++i;
                    return {
                        value,
                        done: false,
                    };
                },
            };
        },
    };
    return Array.from(it);
}
exports.arrayFromRange = arrayFromRange;
function ensureArray(maybeArr) {
    // @ts-ignore Issue with typescript 4.1.3 (not 4.1.2) where the readonly is causing issue
    // with the isArray typing because any[] is no readonly any[]
    return Array.isArray(maybeArr) ? maybeArr : [maybeArr];
}
exports.ensureArray = ensureArray;
function concatAndDedupeById(existingEntities, newEntities) {
    const existingIds = existingEntities.reduce((e, a) => {
        e[a.id] = true;
        return e;
    }, {});
    return existingEntities.concat(newEntities.filter((a) => !existingIds[a.id]));
}
exports.concatAndDedupeById = concatAndDedupeById;
function modifyArrayElementInPlaceById(arrayToModify, modifiedItem) {
    const foundIndex = arrayToModify.findIndex((element) => element.id === modifiedItem.id);
    if (foundIndex < 0) {
        return [...arrayToModify, modifiedItem];
    }
    return [
        ...arrayToModify.slice(0, foundIndex),
        modifiedItem,
        ...arrayToModify.slice(foundIndex + 1),
    ];
}
exports.modifyArrayElementInPlaceById = modifyArrayElementInPlaceById;
function keyById(arr) {
    return arr.reduce((m, v) => {
        m[v.id] = v;
        return m;
    }, {});
}
exports.keyById = keyById;
function makeValueMap(arr) {
    return arr.reduce((m, v) => {
        m[v] = true;
        return m;
    }, {});
}
exports.makeValueMap = makeValueMap;
function areNumberArrayEqual(a, b) {
    if (a.length !== b.length) {
        return false;
    }
    const sortedA = Array.from(a).sort();
    const sortedB = Array.from(b).sort();
    for (let i = 0; i < sortedA.length; ++i) {
        if (sortedA[i] !== sortedB[i]) {
            return false;
        }
    }
    return true;
}
exports.areNumberArrayEqual = areNumberArrayEqual;
function sample(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}
exports.sample = sample;
//# sourceMappingURL=array.js.map